[
  {
    "id": "hart-ducha",
    "name": "Hart Ducha",
    "description": "+20 maks. zdrowia na rangę.",
    "maxRank": 5,
    "modifiers": [
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 20
      }
    ]
  },
  {
    "id": "lekkie-kroki",
    "name": "Lekkie Kroki",
    "description": "+6% szybkości ruchu na rangę.",
    "maxRank": 5,
    "modifiers": [
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": 0.06
      }
    ]
  },
  {
    "id": "przyciaganie",
    "name": "Przyciąganie",
    "description": "+25% zasięgu zbierania doświadczenia na rangę.",
    "maxRank": 3,
    "modifiers": [
      {
        "stat": "pickupRadius",
        "op": "mul",
        "value": 0.25
      }
    ]
  },
  {
    "id": "wyostrzone-zmysly",
    "name": "Wyostrzone Zmysły",
    "description": "+4% szansy na trafienie krytyczne na rangę.",
    "maxRank": 5,
    "modifiers": [
      {
        "stat": "critChance",
        "op": "add",
        "value": 0.04
      }
    ]
  },
  {
    "id": "zawzietosc",
    "name": "Zawziętość",
    "description": "+8% obrażeń wszystkich umiejętności na rangę.",
    "maxRank": 5,
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.08
      }
    ]
  },
  {
    "id": "pospiech",
    "name": "Pośpiech",
    "description": "-6% czasu odnowienia umiejętności na rangę.",
    "maxRank": 5,
    "modifiers": [
      {
        "stat": "cooldown",
        "op": "mul",
        "value": -0.06
      }
    ]
  },
  {
    "id": "odnowa",
    "name": "Odnowa",
    "description": "+0,4 zdrowia na sekundę na rangę.",
    "maxRank": 3,
    "modifiers": [
      {
        "stat": "regen",
        "op": "add",
        "value": 0.4
      }
    ]
  },
  {
    "id": "pierscien-zaru",
    "name": "Pierścień Żaru",
    "description": "Nowa umiejętność: fala ognia wokół postaci.",
    "maxRank": 1,
    "grantsAbility": "pierscien-zaru",
    "requires": [],
    "classes": [
      "arkanista"
    ]
  },
  {
    "id": "podsycony-zar",
    "name": "Podsycony Żar",
    "description": "+20% obrażeń od ognia na rangę.",
    "maxRank": 3,
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.2,
        "tags": [
          "fire"
        ]
      }
    ],
    "requires": [
      {
        "talent": "pierscien-zaru",
        "rank": 1
      }
    ],
    "classes": [
      "arkanista"
    ]
  },
  {
    "id": "zelazna-skora",
    "name": "Żelazna Skóra",
    "description": "+6 pancerza na rangę.",
    "classes": [
      "straznik"
    ],
    "maxRank": 5,
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 6
      }
    ]
  },
  {
    "id": "szeroki-zamach",
    "name": "Szeroki Zamach",
    "description": "+12% zasięgu ciosów i umiejętności obszarowych na rangę.",
    "classes": [
      "straznik",
      "barbarzynca"
    ],
    "maxRank": 4,
    "modifiers": [
      {
        "stat": "area",
        "op": "mul",
        "value": 0.12
      }
    ]
  },
  {
    "id": "szal",
    "name": "Szał",
    "description": "+10% obrażeń i +3% szybkości ruchu na rangę.",
    "classes": [
      "barbarzynca"
    ],
    "maxRank": 4,
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.1
      },
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": 0.03
      }
    ]
  },
  {
    "id": "rozszczepienie",
    "name": "Rozszczepienie",
    "description": "+1 pocisk na rangę.",
    "classes": [
      "arkanista",
      "tropiciel"
    ],
    "maxRank": 3,
    "modifiers": [
      {
        "stat": "projectileCount",
        "op": "add",
        "value": 1,
        "tags": [
          "projectile"
        ]
      }
    ]
  },
  {
    "id": "rezonans",
    "name": "Rezonans",
    "description": "+15% obrażeń arkanicznych na rangę.",
    "classes": [
      "arkanista"
    ],
    "maxRank": 4,
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.15,
        "tags": [
          "arcane"
        ]
      }
    ]
  },
  {
    "id": "lodowa-wlocznia",
    "name": "Lodowa Włócznia",
    "description": "Nowa umiejętność: ciężki pocisk przebijający kilka celów.",
    "classes": [
      "arkanista"
    ],
    "maxRank": 1,
    "grantsAbility": "lodowa-wlocznia"
  },
  {
    "id": "przebicie",
    "name": "Przebicie",
    "description": "Pociski przebijają +1 wroga na rangę.",
    "classes": [
      "tropiciel"
    ],
    "maxRank": 3,
    "modifiers": [
      {
        "stat": "pierce",
        "op": "add",
        "value": 1,
        "tags": [
          "projectile"
        ]
      }
    ]
  },
  {
    "id": "sokoli-wzrok",
    "name": "Sokoli Wzrok",
    "description": "+15% prędkości i zasięgu pocisków na rangę.",
    "classes": [
      "tropiciel"
    ],
    "maxRank": 3,
    "modifiers": [
      {
        "stat": "projectileSpeed",
        "op": "mul",
        "value": 0.15,
        "tags": [
          "projectile"
        ]
      },
      {
        "stat": "range",
        "op": "mul",
        "value": 0.15,
        "tags": [
          "projectile"
        ]
      }
    ]
  },
  {
    "id": "wir-ostrzy",
    "name": "Wir Ostrzy",
    "description": "Nowa umiejętność: obrót raniący wszystkich wokół.",
    "classes": [
      "straznik"
    ],
    "maxRank": 1,
    "grantsAbility": "wir-ostrzy"
  },
  {
    "id": "rozlupanie",
    "name": "Rozłupanie",
    "description": "Nowa umiejętność: miażdżący cios z góry.",
    "classes": [
      "barbarzynca"
    ],
    "maxRank": 1,
    "grantsAbility": "rozlupanie"
  },
  {
    "id": "rzut-nozami",
    "name": "Rzut Nożami",
    "description": "Nowa umiejętność: wachlarz noży na krótki dystans.",
    "classes": [
      "tropiciel"
    ],
    "maxRank": 1,
    "grantsAbility": "rzut-nozami"
  },
  {
    "id": "ciezka-reka",
    "name": "Ciężka Ręka",
    "description": "+15% obrażeń ciosów wręcz (także wirów) na rangę.",
    "classes": [
      "straznik",
      "barbarzynca"
    ],
    "maxRank": 3,
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.15,
        "tags": [
          "melee"
        ]
      }
    ]
  },
  {
    "id": "krazace-ostrza",
    "name": "Krążące Ostrza",
    "description": "Nowa umiejętność: ostrza krążące wokół postaci.",
    "classes": [
      "straznik"
    ],
    "maxRank": 1,
    "grantsAbility": "krazace-ostrza"
  },
  {
    "id": "krag-gniewu",
    "name": "Krąg Gniewu",
    "description": "Nowa umiejętność: stała aura raniąca wrogów wokół.",
    "classes": [
      "barbarzynca"
    ],
    "maxRank": 1,
    "grantsAbility": "krag-gniewu"
  },
  {
    "id": "lancuch-blyskawic",
    "name": "Łańcuch Błyskawic",
    "description": "Nowa umiejętność: błyskawica przeskakująca między wrogami.",
    "classes": [
      "arkanista"
    ],
    "maxRank": 1,
    "grantsAbility": "lancuch-blyskawic"
  },
  {
    "id": "mrozna-aura",
    "name": "Mroźna Aura",
    "description": "Nowa umiejętność: aura chłodu, która spowalnia wrogów.",
    "classes": [
      "arkanista"
    ],
    "maxRank": 1,
    "grantsAbility": "mrozna-aura"
  },
  {
    "id": "wnyki",
    "name": "Wnyki",
    "description": "Nowa umiejętność: pułapka wybuchająca pod wrogiem.",
    "classes": [
      "tropiciel"
    ],
    "maxRank": 1,
    "grantsAbility": "wnyki"
  }
]
